// @flow
import React, { Component } from "react";
import SearchIcon from "react-feather/dist/icons/search";
import Mail from "react-feather/dist/icons/mail";
import MapButton from "./MapButton/MapButton";
import Hero from "./Hero/Hero";
import BreachItem from "./BreachItem/BreachItem";
import FilterBar from "./FilterBar/FilterBar";
import SubscribeModal from "../shared/SubscribeModal/SubscribeModal";
import container from "../../styles/container.module.css";
import styles from "./landing.module.css";

type Props = {
  data: {
    breaches: {
      edges: Array<{ node: PrismicBreach }>
    }
  }
};

type State = {
  isMapFullscreen: boolean,
  isSubscribeModalOpen: boolean,
  selectedVector: ?string,
  severity: ?number
};

const BreachEmpty = () => (
  <div className={container.default}>
    <div className={styles.NoFilterBox}>
      <div className={styles.NoFilterIcon}>
        <SearchIcon size={50} />
      </div>
      <span>
        No breaches matching these criteria were found.
        <br />
        Try modifying the filters to see more results.
      </span>
    </div>
  </div>
);

class Landing extends Component<Props, State> {
  state = {
    isMapFullscreen: false,
    isSubscribeModalOpen: false,
    selectedVector: null,
    severity: null
  };

  toggleMap = (e: Event) => {
    e && e.preventDefault;
    this.setState(prevState => ({
      isMapFullscreen: !prevState.isMapFullscreen
    }));
  };

  toggleSubscribe = (e: Event) => {
    e && e.preventDefault;
    this.setState(prevState => ({
      isSubscribeModalOpen: !prevState.isSubscribeModalOpen
    }));
  };

  closeSubscribe = (e: Event) => {
    e && e.preventDefault;
    this.setState({
      isSubscribeModalOpen: false
    });
  };

  updateFilter = ({ selectedVector, severity }) => {
    this.setState({
      selectedVector,
      severity
    });
  };

  get breachCoordinates(): Array<{ latitude: number, longitude: number }> {
    return this.props.data.breaches.edges.map(({ node }) => node.data.location);
  }

  get currentBreaches() {
    const { edges } = this.props.data.breaches;
    const { severity, selectedVector } = this.state;

    const filteredEdges = edges.filter(edge => {
      let matched = true;
      if (severity) {
        matched = edge.node.data.severity === severity;
      }
      if (matched && selectedVector) {
        matched = edge.node.data.attack_vector === selectedVector;
      }
      return matched;
    });

    if (filteredEdges.length === 0) {
      return <BreachEmpty />;
    }

    return filteredEdges.map(({ node }) => (
      <BreachItem
        key={node.uid}
        uid={node.uid}
        title={node.data.title.text}
        companyName={node.data.company_name}
        companyUrl={node.data.company_url.url}
        disclosedAt={node.data.disclosed_at}
        attackVector={node.data.attack_vector}
        severity={node.data.severity}
      />
    ));
  }

  render() {
    const {
      data: {
        breaches: { edges }
      }
    } = this.props;
    const {
      isMapFullscreen,
      selectedVector,
      severity,
      isSubscribeModalOpen
    } = this.state;

    let isSubscribed = null;
    if (typeof window !== `undefined`) {
      isSubscribed = /subscribed/.test(window.location.search);
    }

    return (
      <div>
        <Hero breaches={edges} isMapFullscreen={isMapFullscreen} />
        <MapButton onClick={this.toggleMap} isMapFullscreen={isMapFullscreen} />
        <div className={styles.wrapper}>
          <button
            type="button"
            className={styles.button}
            onClick={isSubscribed ? () => {} : this.toggleSubscribe}
            style={{
              backgroundColor: isSubscribed ? "green" : "black"
            }}
          >
            {isSubscribeModalOpen
              ? `Subscribe`
              : isSubscribed
                ? `Subscribed!`
                : `Subscribe`}
            <Mail height={14} />
          </button>
          <SubscribeModal
            isSubscribeModalOpen={isSubscribeModalOpen}
            close={this.closeSubscribe}
          />
        </div>
        <FilterBar
          updateFilter={this.updateFilter}
          selectedVector={selectedVector}
          severity={severity}
        />
        <ul style={{ margin: 0, padding: 0 }}>{this.currentBreaches}</ul>
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing/Landing.js